import { RecordPageComponent } from './../record-page/record-page.component';
import { MessageDetailsComponent } from 'src/app/layout/Inbox/MessageDetails/MessageDetails.component';
import {
  InboxResponse,
  InboxParams,
} from './../Inbox/InboxInterfaces/inboxParams';
import { InboxService } from 'src/app/services/InboxService.service';
import {
  Component,
  OnInit,
  Input,
  HostListener,
  ViewChild,
  TemplateRef,
} from '@angular/core';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterEvent,
} from '@angular/router';
import { AuthenticationService } from 'src/app/authentication.service';
import { App } from 'src/app/models/app';
import { LayoutService } from '../layout.service';
import { RecordListDrawerArgs } from 'src/app/models/record-list-drawer-args';
import * as g from 'src/app/globals';
import { NzDrawerRef, NzDrawerService } from 'ng-zorro-antd/drawer';
import { ActivityObject } from '../Inbox/InboxInterfaces/activityObject';
import { switchMap, tap } from 'rxjs/operators';
import { NotifyService } from '@app/services/notify.service';
import { ShoppingCartService } from '@app/apps/shoppingCart/shoppingCart.service';
import { NzModalService } from 'ng-zorro-antd/modal';
import { AnnouncementModalComponentComponent } from '../announcement-modal-component/announcement-modal-component.component';
import { MsGraphService } from '@app/services/ms-graph.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-application-index',
  templateUrl: './application-index.component.html',
  styleUrls: ['./application-index.component.less'],
})
export class ApplicationIndexComponent implements OnInit {
  global = g;

  @ViewChild('msAuthForm') msAuthForm: TemplateRef<any>;

  @Input() app: App;
  @Input() header: TemplateRef<any>;
  @ViewChild('notificationDrawer', { static: false })
  notificationDrawer?: TemplateRef<{
    $implicit: {};
    drawerRef: NzDrawerRef<any>;
  }>;
  public innerWidth: any;
  nowYear = new Date().getFullYear();
  collapsibleHeader = true;
  headerCollapsed = false;
  appId = g.currentAppId;
  baseUrl = g.baseUrl;
  screenSize: string;
  appsUrl: string;
  isCollapsed: boolean;
  userIdentity: any;
  isLoading = true;
  msAuthEmail: string;
  isActivitiesLoading = true;
  activities: Array<ActivityObject>;
  unreadMessages: InboxResponse = {
    data: [],
    recordsFiltered: 0,
    recordsTotal: 0,
  };
  searchUser = '';
  recordPageVisible = false;
  recordPageModuleId: number;
  recordPageSelectedId: string;
  customerCompanies: any[] = [];
  companyNames: string[] = [];
  companyNameIDs: any[] = [];
  companyUsers = [];
  orginalCompanyUsers = [];
  recordListVisible = false;
  footerLeftPadding = 0;
  recordListDrawerArgs: RecordListDrawerArgs;
  translations = [];
  ajaxLoading: boolean;
  unreadmessagesCount: number;
  containerTranspareBG = false;
  containerAdditionalClass = '';
  footerAdditionalClass = '';
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.innerWidth = window.innerWidth;
  }

  totals: { price: number; quantity: number } = {
    price: 0,
    quantity: 0,
  };
  showAlertBell: boolean = false;

  constructor(
    private shoppingCartService: ShoppingCartService,
    private router: Router,
    private layoutService: LayoutService,
    private notifyService: NotifyService,
    private authenticationService: AuthenticationService,
    private inboxService: InboxService,
    private drawerService: NzDrawerService,
    private modalService: NzModalService,
    private graphService: MsGraphService,
    private msg: NzMessageService,
    private fb: FormBuilder
  ) {
    this.containerTranspareBG = layoutService.containerTransparentBG;
    this.containerAdditionalClass = layoutService.containerAdditionalClass;
    this.footerAdditionalClass = layoutService.footerAdditionalClass;
    this.footerLeftPadding = layoutService.containerFooterLeftPadding;
    this.screenSize = layoutService.screenSize;
    this.isCollapsed = true;

    layoutService.screenSizeEmitter.subscribe((size) => {
      this.screenSize = size;
    });

    layoutService.containerTransparentBGEmitter.subscribe(
      (containerTranspareBG) => {
        this.containerTranspareBG = containerTranspareBG;
      }
    );

    layoutService.containerFooterLeftPaddingEmitter.subscribe(
      (footerLeftPadding) => {
        this.footerLeftPadding = footerLeftPadding;
      }
    );

    layoutService.containerAdditionalClassEmitter.subscribe(
      (containerAdditionalClass) => {
        this.containerAdditionalClass = containerAdditionalClass;
      }
    );

    layoutService.footerAdditionalClassEmitter.subscribe(
      (footerAdditionalClass) => {
        this.footerAdditionalClass = footerAdditionalClass;
      }
    );

    this.innerWidth = window.innerWidth;
  }

  ngOnInit(): void {
    this.showAlertBell = g.notifications.disableAlertBell;
    this.inboxService.updateUnreadMessagesEmmiter.subscribe(() => {
      this.getUnreadMessages();
    });

    this.shoppingCartService.UpdateLines.subscribe(() => {
      this._getShoppingCart();
    });

    // this.getActivities();
    this.translations = g.translationsData;
    this.authenticationService.getIdentityDetails().subscribe((user) => {
      this.userIdentity = user;
      g.setUserIdentity(this.userIdentity);

      if (g.enableAnnouncement) {
        if (
          this.getValueFromLocalStorage(
            `ShowAnnouncement[${g.userIdentity.CompanyDB}]`,
            ''
          ) === 'true'
        ) {
          this.showAnnouncements();
          localStorage.setItem(
            `ShowAnnouncement[${g.userIdentity.CompanyDB}]`,
            'false'
          );
        }
      }

      clearInterval(this.notifyService.settimeOut);
      this.notifyService.start();
      this.getCustomerCompanies();
      if (this.userIdentity.Area === 1) {
        this.getUnreadMessages();
        this.appsUrl = '/apps/core/index/stay';
      } else if (this.userIdentity.Area === 2) {
        this.appsUrl = '/apps/core/index/stay';

        this._getShoppingCart();
      }

      if (this.userIdentity.UserFullName.split(' ').length === 1) {
        this.userIdentity.AvatarText =
          this.userIdentity.UserFullName[0] +
          ' ' +
          this.userIdentity.UserFullName[1];
      } else {
        this.userIdentity.AvatarText =
          this.userIdentity.UserFullName.split(' ')[0][0] +
          ' ' +
          this.userIdentity.UserFullName.split(' ')[1][0];
      }

      this.layoutService
        .getMenus(this.app.parentMenuId)
        .subscribe((d: any[]) => {
          this.app.menus = d;
          this.isLoading = false;
        });
    });

    this.router.events.subscribe((e: RouterEvent) => {
      this.navigationInterceptor(e);
    });

    this.getHeaderCollapsed();
  }

  getValueFromLocalStorage(key: string, defaultValue: any): string {
    let storedValue = localStorage.getItem(key);
    if (
      storedValue === undefined ||
      storedValue === null ||
      storedValue === ''
    ) {
      localStorage.setItem(key, defaultValue);
      storedValue = defaultValue;
    }

    return storedValue;
  }

  changeHeaderCollapsed() {
    this.headerCollapsed = !this.headerCollapsed;
    localStorage.setItem('headerCollapsed', this.headerCollapsed.toString());
  }

  @ViewChild('htmlContentTemplate', { static: true })
  htmlContentTemplate!: TemplateRef<any>;

  async showAnnouncements() {
    console.log(g.userIdentity);
    this.layoutService
      .getCustomerAnnouncement(g.userIdentity.UserCode)
      .subscribe(async (result: any) => {
        console.log('result', result.rows.rowsArray);
        for (const message of result.rows.rowsArray) {
          await this.openModal(message);
        }
      });
    //const announcements = ['Message 1', 'Message 2', 'Message 3'];
  }

  openModal(message: any): Promise<void> {
    return new Promise<void>((resolve) => {
      const modalRef = this.modalService.create({
        nzTitle: message.U_TITLE,
        nzStyle: { width: 'fit-content', maxWidth: '90vw' },
        nzContent: AnnouncementModalComponentComponent,
        nzComponentParams: {
          htmlContent: message.U_BODY,
        },
        nzOnOk: () => {
          this.layoutService
            .setCustomerAnnouncement(
              message.Code,
              g.userIdentity.CardCode,
              g.userIdentity.ContactCode.toString(),
              g.userIdentity.UserCode
            )
            .subscribe();
          resolve();
        },
        nzClosable: false,
        nzMaskClosable: false,
        nzCancelText: null,
        nzKeyboard: false,
      });
    });
  }

  getHeaderCollapsed() {
    this.headerCollapsed = false;
    const storageValue = localStorage.getItem('headerCollapsed');

    if (storageValue) {
      this.headerCollapsed = storageValue === 'true';
    }
  }

  navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      this.ajaxLoading = true;
    }
    if (event instanceof NavigationEnd) {
      this.ajaxLoading = false;
    }

    // Set loading state to false in both of the below events to hide the spinner in case a request fails
    if (event instanceof NavigationCancel) {
      this.ajaxLoading = false;
    }
    if (event instanceof NavigationError) {
      this.ajaxLoading = false;
    }
  }

  toggleSideMenu(): void {
    this.isCollapsed = !this.isCollapsed;
  }

  menuSelected() {
    this.isCollapsed = true;
  }

  logout(): void {
    this.authenticationService.logout().subscribe((d) => {
      this.resetThemeSettings();
      if (g.userIdentity.Area === 1) {
        this.router.navigate(['/apps/authentication/login']);
      } else {
        this.router.navigate(['/apps/authentication/external-login']);
      }
    });
  }
  resetThemeSettings() {
    const rootStyles = getComputedStyle(document.documentElement);
    let defaultRgb = rootStyles.getPropertyValue('--bweb-primary-rgb')?.trim();

    if (defaultRgb) {
      g.setPrimaryColor(defaultRgb);
    }
    g.setLogoUrl(null);
  }

  getUnreadMessages() {
    const inboxparams: InboxParams = {
      filters: {},
      page: 0,
      pageSize: 50,
      sortByDir: 'DESC',
      sortByField: 'RecDate',
      term: '',
    };
    this.inboxService.getInbox(inboxparams).subscribe((messages) => {
      this.unreadmessagesCount = messages.data.filter(
        (x) => x.WasRead !== 'Y'
      ).length;
      this.unreadMessages = messages;
    });
  }

  openMessageDrawer(code: string) {
    if (this.innerWidth < 993) {
      const drawerRef = this.drawerService.create<
        MessageDetailsComponent,
        { value: string },
        string
      >({
        nzTitle: 'Message Details',
        nzContent: MessageDetailsComponent,
        nzWidth: '100%',
        nzContentParams: {
          value: code,
          isDrawer: true,
        },
      });
    } else {
      const drawerRef = this.drawerService.create<
        MessageDetailsComponent,
        { value: string },
        string
      >({
        nzTitle: 'Message Details',
        nzContent: MessageDetailsComponent,
        nzWidth: '50%',
        nzContentParams: {
          value: code,
          isDrawer: true,
        },
      });
    }
  }
  getActivities() {
    this.inboxService
      .getActivities()
      .pipe(
        tap(() => {
          this.isActivitiesLoading = false;
        })
      )
      .subscribe((data) => {
        this.activities = data.rowsArray;
      });
  }
  openNotificationDrawer(): void {
    this.inboxService.updateUnreadMessagesEmmiter.emit();
    if (this.innerWidth < 993) {
      this.drawerService.create({
        nzTitle: 'Notification',
        nzContent: this.notificationDrawer,
        nzWidth: '100%',
      });
    } else {
      this.drawerService.create({
        nzTitle: 'Notification',
        nzContent: this.notificationDrawer,
        nzWidth: '50%',
      });
    }
  }

  openComponent(activityCode): void {
    RecordPageComponent.openRecordPage(this.drawerService, {
      moduleId: 25,
      actionType: 'Edit',
      drawerTitle: 'Activity',
      inDrawer: true,
      parentComponent: this,
      recordId: activityCode,
      recordModel: undefined,
    });
  }

  openActivityTab() {
    this.getActivities();
  }

  getCustomerCompanies() {
    const contactId = g.userIdentity.ContactCode;
    const company = g.userIdentity.CompanyDB;
    this.layoutService
      .getContactCompanies(contactId, company)
      .pipe(
        tap((res: any) => {
          if (res.Success) {
            this.customerCompanies = res.company;
            this.companyNames = res.CompanyNames;
            this.companyNameIDs = res.CompanyNameIDs;
            this.companyUsers = res.CompanyUsers;
            this.orginalCompanyUsers = LayoutService.HardCopyObject(
              res.CompanyUsers
            );
            this.companyUsers.forEach((user) => {
              user.CompanyDB = this.customerCompanies.find(
                (x) => x.ContactCode === +user.CntctCode
              ).CompanyDB;
              user.CompanyDBName = this.companyNameIDs.find(
                (x) => x.companyDB === user.CompanyDB
              ).companyName;
            });
          }
        })
      )
      .subscribe();
  }
  searchUserChange() {
    if (this.searchUser === '') {
      this.companyUsers = LayoutService.HardCopyObject(
        this.orginalCompanyUsers
      );
      return;
    }
    this.companyUsers = this.companyUsers.filter(
      (x) =>
        x.CardName.toLowerCase().includes(this.searchUser.toLowerCase()) ||
        x.CntctName.toLowerCase().includes(this.searchUser.toLowerCase())
    );
    console.log(this.companyUsers);
    console.log(this.searchUser);
  }
  changeContactCompany(user) {
    const contactId = user.CntctCode;
    const contactCompany = this.customerCompanies.find(
      (x) => x.ContactCode === +contactId
    ).CompanyDB;
    this.layoutService
      .ChangeLoggedCompany(contactId, contactCompany)
      .pipe(
        tap((response: any) => {
          if (response.Success) {
            localStorage.setItem(`ShowAnnouncement[${contactCompany}]`, 'true');
            window.location.assign(window.location.origin);
          }
        })
      )
      .subscribe();
  }

  openShoppingCart() {
    this.router.navigate(['/apps/external-portal/app-container/10/shopping']);
  }

  _getShoppingCart() {
    let shoppingCartId = '';
    this.shoppingCartService
      .getListOfShoppingCarts(g.userIdentity.CardCode, '1')
      .pipe(
        tap((response: any) => {
          const results = response.Resault_Value.rowsArray as any[];
          if (results.length === 0) {
            return;
          }
          shoppingCartId = results[0].U_DocEntry;
        }),
        switchMap(() =>
          this.shoppingCartService.getShoppingCartInfo(
            '1',
            shoppingCartId.toString()
          )
        ),
        tap((cartInfo) => {
          const cartLines = cartInfo?.Resault_Value?.Lines;
          if (cartLines == null || cartLines?.length === 0) {
            return;
          }
          let quantity = 0;
          let total = 0;
          cartLines.forEach((cartLine) => {
            if (cartLine != null) {
              quantity += cartLine.Quantity;
              total += cartLine.LineTotal;
            }
          });
          this.totals.quantity = quantity;
          this.totals.price = total;
        })
      )
      .subscribe();
  }

  authOffice365(): void {
    const modalRef = this.modalService.create({
      nzTitle: 'Authenticate Office365',
      nzContent: this.msAuthForm,
      nzFooter: [
        {
          label: 'Cancel',
          onClick: () => modalRef.destroy(),
        },
        {
          label: 'Authenticate',
          type: 'primary',
          loading: false,
          onClick: () => {
            const email = this.msAuthEmail?.trim();
            if (!email) {
              this.msg.warning('Please insert a valid email address.');
              return;
            }

            // validate email format
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(email)) {
              this.msg.warning('Please insert a valid email address.');
              return;
            }

            this.graphService.getAuthenticationUrl(email).subscribe({
              next: (res) => {
                modalRef.destroy();
                this.msg.info('Redirecting to Microsoft login...');
                window.location.href = res.authUrl.Item1;
              },
              error: (err) => {
                console.error(err);
                this.msg.error('Authentication initialization failed.');
              },
            });
          },
        },
      ],
    });
  }
}
